import { ConvertStringToHtmlId } from '../../libs/ts/ConvertStringToHtmlId';
import { FieldValues, Path, useFormContext } from 'react-hook-form';
import { FormComponentProps } from '../types';

interface FormCheckboxProps<T> extends FormComponentProps<T> {
  title: string;
  description?: string;
  group?: string;
}

export const FormCheckbox = <T extends FieldValues>(props: FormCheckboxProps<T>) => {
  const checkboxTitle = ConvertStringToHtmlId(props.title);

  const { register } = useFormContext<T>();
  const inputProps = register<Path<T>>(props.name);

  return (
    <div>
      <div className="flex flex-row w-full">
        <input
          {...inputProps}
          type="checkbox"
          id={checkboxTitle}
          name={props.name}
          readOnly={props.readonly}
          disabled={props.readonly}
          className={`translate-y-1 w-4 h-4 appearance-none checked:appearance-auto accent-solid-bold-green border-[2px] rounded-[2px] border-secondary-deep-blue-30 bg-interactive-bold-green-db-12 checked:border-solid-bold-green ${!props.readonly ? 'hover:border-solid-bold-green' : ''}`}
        />
        <label htmlFor={checkboxTitle} className="ml-7">
          {props.title}
        </label>
      </div>

      {props.description !== undefined && (
        <span
          className={`block whitespace-pre-wrap mt-3 mb-5 ml-8 mr-8 leading-6 text-sm text-secondary-deep-blue-20 font-italic overflow-hidden transition-[max-height] ease-in duration-300 max-h-0`}
        >
          {props.description}
        </span>
      )}
    </div>
  );
};
